// Shared state for the postal code change flag
let isPostalCodeChanged = false;

export const setIsPostalCodeChanged = (value) => {
  isPostalCodeChanged = value;
};

export const getIsPostalCodeChanged = () => {
  return isPostalCodeChanged;
};